import * as actionTypes from "./actionTypes";
import { serviceService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";

export function getServices({
  page = constants.GET_ALL_ITEMS,
  filter,
  categoryId = constants.GET_ALL_ITEMS,
  reset,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_SERVICES });

      dispatch({ type: actionTypes.FETCH_SERVICES });

      const response = await serviceService.getAll(page, filter, categoryId);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_SERVICES_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_SERVICES_SUCCESS,
        payload: {
          services: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_SERVICES_FAILURE);
    }
  };
}

export function resetServices() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SERVICES,
    });
  };
}

export function getServicesOffer({
  page = 1,
  filter = "",
  reset = false,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_SERVICES_OFFER });
      dispatch({ type: actionTypes.FETCH_SERVICES_OFFER });

      const response = await serviceService.getAll(
        page,
        filter,
        constants.GET_ALL_ITEMS
      );
      const data = response.data;
      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_SERVICES_OFFER_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_SERVICES_OFFER_SUCCESS,
        payload: {
          services: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FETCH_SERVICES_OFFER_FAILURE
      );
    }
  };
}

export function resetServicesOffer() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SERVICES_OFFER,
    });
  };
}

export function getService(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.RESET_SERVICE });
      dispatch({ type: actionTypes.FETCH_SERVICE });

      const response = await serviceService.get(id);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_SERVICE_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.FETCH_SERVICE_SUCCESS,
        payload: { service: data },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_SERVICE_FAILURE);
    }
  };
}

export function resetService() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_SERVICE,
    });
  };
}

export function createService(service, imgV, imgH, onSuccess) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.CREATE_SERVICE });

      const response = await serviceService.create(service, imgV, imgH);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.CREATE_SERVICE_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.CREATE_SERVICE_SUCCESS,
        payload: {
          service: data,
        },
      });

      dispatch({ type: actionTypes.RESET_CREATE_SERVICE });

      onSuccess();
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.CREATE_SERVICE_SUCCESS);
    }
  };
}

export function resetCreateService() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_CREATE_SERVICE,
    });
  };
}

export function updateService(id, service, imgV, imgH, onSuccess) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.UPDATE_SERVICE });

      const response = await serviceService.update(id, imgV, imgH, service);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.UPDATE_SERVICE_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.UPDATE_SERVICE_SUCCESS,
        payload: { service: data },
      });

      onSuccess();
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.UPDATE_SERVICE_FAILURE);
    }
  };
}

export function resetUpdateService() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_UPDATE_SERVICE,
    });
  };
}

export function deleteService(id, onSuccess) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.DELETE_SERVICE });

      const response = await serviceService.deleteService(id);

      dispatch({
        type: actionTypes.DELETE_SERVICE_SUCCESS,
        payload: {
          service: { id },
        },
      });

      dispatch({ type: actionTypes.RESET_DELETE_SERVICE });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.DELETE_SERVICE_FAILURE);
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/service/actions.js